// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { FaTimes, FaPlane, FaCalendarAlt, FaUser, FaFileUpload } from "react-icons/fa";
// import { toast } from "react-toastify";

// const AdminCustomFlightModal = ({ onClose, onSuccess }) => {
//   const [users, setUsers] = useState([]);
//   const [loadingUsers, setLoadingUsers] = useState(true);
//   const [airports, setAirports] = useState([]);

//   const [formData, setFormData] = useState({
//     userId: "",
//     fromCity: "",
//     toCity: "",
//     tripType: "One Way",
//     departureDate: "",
//     returnDate: "",
//     pnr: "",
//     returnPnr: "",
//     price: "",
//   });
//   const [file, setFile] = useState(null);
//   const [submitting, setSubmitting] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [showDropdown, setShowDropdown] = useState(false);
//   const [fromSearch, setFromSearch] = useState("");
//   const [showFromDropdown, setShowFromDropdown] = useState(false);
//   const [toSearch, setToSearch] = useState("");
//   const [showToDropdown, setShowToDropdown] = useState(false);

//   const filteredUsers = users.filter((u) => {
//     const searchLower = searchTerm.toLowerCase();
//     const name = u.username?.toLowerCase() || "";
//     const email = u.email?.toLowerCase() || "";
//     return name.includes(searchLower) || email.includes(searchLower);
//   });

//   const filteredFromAirports = airports.filter((a) => {
//     const searchLower = fromSearch.toLowerCase();
//     const code = a.airportcode?.toLowerCase() || a.code?.toLowerCase() || "";
//     const name = a.airportname?.toLowerCase() || a.name?.toLowerCase() || "";
//     const city = a.airportcity?.toLowerCase() || a.city?.toLowerCase() || "";
//     return code.includes(searchLower) || name.includes(searchLower) || city.includes(searchLower);
//   }).slice(0, 20);

//   const filteredToAirports = airports.filter((a) => {
//     const searchLower = toSearch.toLowerCase();
//     const code = a.airportcode?.toLowerCase() || a.code?.toLowerCase() || "";
//     const name = a.airportname?.toLowerCase() || a.name?.toLowerCase() || "";
//     const city = a.airportcity?.toLowerCase() || a.city?.toLowerCase() || "";
//     return code.includes(searchLower) || name.includes(searchLower) || city.includes(searchLower);
//   }).slice(0, 20);

//   useEffect(() => {
//     fetchUsers();
//     fetchAirports();
//   }, []);

//   const fetchAirports = async () => {
//     try {
//       const BASE = import.meta.env.VITE_URL || import.meta.env.VITE_URL2 || "http://localhost:3000";
//       const res = await axios.get(`${BASE}/api/airport`, { withCredentials: true });
//       if (res.data.success && res.data.data) {
//         setAirports(res.data.data);
//       }
//     } catch (err) {
//       console.error("Failed to load airports", err);
//     }
//   };

//   const fetchUsers = async () => {
//     try {
//       const BASE = import.meta.env.VITE_URL || import.meta.env.VITE_URL2 || "http://localhost:3000";
//       const res = await axios.get(`${BASE}/api/user?limit=1000`, { withCredentials: true });
//       if (res.data.success) {
//         setUsers(res.data.data);
//       }
//     } catch (err) {
//       console.error("Failed to load users", err);
//       toast.error("Failed to load users for dropdown");
//     } finally {
//       setLoadingUsers(false);
//     }
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!formData.userId || !formData.fromCity || !formData.toCity || !formData.departureDate) {
//       toast.error("Please fill all required fields");
//       return;
//     }

//     if (formData.tripType === "Round Trip" && !formData.returnDate) {
//       toast.error("Return date is required for round trips");
//       return;
//     }

//     setSubmitting(true);
//     try {
//       const BASE = import.meta.env.VITE_URL || import.meta.env.VITE_URL2 || "http://localhost:3000";
//       const payload = new FormData();
//       payload.append("userId", formData.userId);
//       payload.append("fromCity", formData.fromCity);
//       payload.append("toCity", formData.toCity);
//       payload.append("tripType", formData.tripType);
//       payload.append("departureDate", formData.departureDate);
//       if (formData.returnDate) payload.append("returnDate", formData.returnDate);
//       if (formData.pnr) payload.append("pnr", formData.pnr);
//       if (formData.returnPnr && formData.tripType === "Round Trip") payload.append("returnPnr", formData.returnPnr);
//       if (formData.price) payload.append("price", formData.price);
//       if (file) payload.append("eTicket", file);

//       const res = await axios.post(`${BASE}/api/booking/admin/custom-booking`, payload, {
//         withCredentials: true,
//         headers: { "Content-Type": "multipart/form-data" },
//       });

//       if (res.data.success) {
//         toast.success("Custom flight booked successfully");
//         onSuccess();
//       }
//     } catch (error) {
//       console.error(error);
//       toast.error(error.response?.data?.message || "Failed to create custom flight");
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 overflow-y-auto">
//       <div className="bg-white rounded-xl shadow-xl w-full max-w-2xl my-8 relative">
//         <div className="flex justify-between items-center p-6 border-b border-gray-100">
//           <h2 className="text-xl font-bold text-gray-800 flex items-center gap-2">
//             <FaPlane className="text-blue-500" /> Create Custom Flight Booking
//           </h2>
//           <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-full text-gray-500 transition-colors">
//             <FaTimes />
//           </button>
//         </div>

//         <form onSubmit={handleSubmit} className="p-6">
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

//             {/* User Selection */}
//             <div className="col-span-1 md:col-span-2 relative">
//               <label className="block text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
//                 <FaUser className="text-gray-400" /> Select User *
//               </label>

//               <div className="relative">
//                 <input
//                   type="text"
//                   placeholder="Search user by name or email..."
//                   value={searchTerm}
//                   onChange={(e) => {
//                     setSearchTerm(e.target.value);
//                     setShowDropdown(true);
//                     if (!e.target.value) setFormData(prev => ({ ...prev, userId: "" }));
//                   }}
//                   onFocus={() => setShowDropdown(true)}
//                   onBlur={() => setShowDropdown(false)}
//                   className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
//                 />

//                 {showDropdown && (
//                   <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-auto">
//                     {filteredUsers.length > 0 ? (
//                       filteredUsers.map(u => (
//                         <div
//                           key={u._id}
//                           className={`px-4 py-2 cursor-pointer hover:bg-blue-50 ${formData.userId === u._id ? "bg-blue-100" : ""}`}
//                           onMouseDown={(e) => {
//                             e.preventDefault(); // Prevents input blur before click registers
//                             setFormData(prev => ({ ...prev, userId: u._id }));
//                             setSearchTerm(`${u.username || u.email} (${u.email})`);
//                             setShowDropdown(false);
//                           }}
//                         >
//                           {u.username || u.email} ({u.email})
//                         </div>
//                       ))
//                     ) : (
//                       <div className="px-4 py-2 text-gray-500">No users found</div>
//                     )}
//                   </div>
//                 )}
//               </div>
//               {loadingUsers && <span className="text-xs text-blue-500 mt-1">Loading users...</span>}
//             </div>

//             {/* Cities */}
//             <div className="relative">
//               <label className="block text-sm font-semibold text-gray-700 mb-2">From City *</label>
//               <input
//                 type="text"
//                 placeholder="E.g. Delhi (DEL)"
//                 value={fromSearch}
//                 onChange={(e) => {
//                   setFromSearch(e.target.value);
//                   setShowFromDropdown(true);
//                   if (!e.target.value) setFormData(prev => ({ ...prev, fromCity: "" }));
//                 }}
//                 onFocus={() => setShowFromDropdown(true)}
//                 onBlur={() => setShowFromDropdown(false)}
//                 className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
//               />
//               {showFromDropdown && (
//                 <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-auto">
//                   {filteredFromAirports.length > 0 ? (
//                     filteredFromAirports.map((a, idx) => {
//                       const display = `${a.airportcity || a.city} (${a.airportcode || a.code})`;
//                       return (
//                         <div
//                           key={idx}
//                           className="px-4 py-2 cursor-pointer hover:bg-blue-50 text-sm"
//                           onMouseDown={(e) => {
//                             e.preventDefault();
//                             setFormData(prev => ({ ...prev, fromCity: display }));
//                             setFromSearch(display);
//                             setShowFromDropdown(false);
//                           }}
//                         >
//                           <div className="font-semibold">{a.airportcity || a.city}</div>
//                           <div className="text-xs text-gray-500">{a.airportname || a.name} - {a.airportcode || a.code}</div>
//                         </div>
//                       );
//                     })
//                   ) : (
//                     <div className="px-4 py-2 text-gray-500">No cities found</div>
//                   )}
//                 </div>
//               )}
//             </div>

//             <div className="relative">
//               <label className="block text-sm font-semibold text-gray-700 mb-2">To City *</label>
//               <input
//                 type="text"
//                 placeholder="E.g. Mumbai (BOM)"
//                 value={toSearch}
//                 onChange={(e) => {
//                   setToSearch(e.target.value);
//                   setShowToDropdown(true);
//                   if (!e.target.value) setFormData(prev => ({ ...prev, toCity: "" }));
//                 }}
//                 onFocus={() => setShowToDropdown(true)}
//                 onBlur={() => setShowToDropdown(false)}
//                 className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
//               />
//               {showToDropdown && (
//                 <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-auto">
//                   {filteredToAirports.length > 0 ? (
//                     filteredToAirports.map((a, idx) => {
//                       const display = `${a.airportcity || a.city} (${a.airportcode || a.code})`;
//                       return (
//                         <div
//                           key={idx}
//                           className="px-4 py-2 cursor-pointer hover:bg-blue-50 text-sm"
//                           onMouseDown={(e) => {
//                             e.preventDefault();
//                             setFormData(prev => ({ ...prev, toCity: display }));
//                             setToSearch(display);
//                             setShowToDropdown(false);
//                           }}
//                         >
//                           <div className="font-semibold">{a.airportcity || a.city}</div>
//                           <div className="text-xs text-gray-500">{a.airportname || a.name} - {a.airportcode || a.code}</div>
//                         </div>
//                       );
//                     })
//                   ) : (
//                     <div className="px-4 py-2 text-gray-500">No cities found</div>
//                   )}
//                 </div>
//               )}
//             </div>

//             {/* Trip Type */}
//             <div className="col-span-1 md:col-span-2">
//               <label className="block text-sm font-semibold text-gray-700 mb-2">Trip Type *</label>
//               <div className="flex gap-4">
//                 <label className="flex items-center gap-2 cursor-pointer">
//                   <input
//                     type="radio"
//                     name="tripType"
//                     value="One Way"
//                     checked={formData.tripType === "One Way"}
//                     onChange={handleChange}
//                     className="w-4 h-4 text-blue-600 focus:ring-blue-500"
//                   />
//                   <span>One Way</span>
//                 </label>
//                 <label className="flex items-center gap-2 cursor-pointer">
//                   <input
//                     type="radio"
//                     name="tripType"
//                     value="Round Trip"
//                     checked={formData.tripType === "Round Trip"}
//                     onChange={handleChange}
//                     className="w-4 h-4 text-blue-600 focus:ring-blue-500"
//                   />
//                   <span>Round Trip</span>
//                 </label>
//               </div>
//             </div>

//             {/* Dates */}
//             <div>
//               <label className="block text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
//                 <FaCalendarAlt className="text-gray-400" /> Departure Date *
//               </label>
//               <input
//                 type="date"
//                 name="departureDate"
//                 value={formData.departureDate}
//                 onChange={handleChange}
//                 required
//                 className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
//               />
//             </div>
//             {formData.tripType === "Round Trip" && (
//               <div>
//                 <label className="block text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
//                   <FaCalendarAlt className="text-gray-400" /> Return Date *
//                 </label>
//                 <input
//                   type="date"
//                   name="returnDate"
//                   value={formData.returnDate}
//                   onChange={handleChange}
//                   required
//                   className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
//                 />
//               </div>
//             )}

//             {/* PNR */}
//             {formData.tripType === "Round Trip" ? (
//               <>
//                 <div>
//                   <label className="block text-sm font-semibold text-gray-700 mb-2">Onward PNR (Optional)</label>
//                   <input
//                     type="text"
//                     name="pnr"
//                     value={formData.pnr}
//                     onChange={handleChange}
//                     placeholder="e.g. ABC123XYZ"
//                     className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
//                   />
//                 </div>
//                 <div>
//                   <label className="block text-sm font-semibold text-gray-700 mb-2">Return PNR (Optional)</label>
//                   <input
//                     type="text"
//                     name="returnPnr"
//                     value={formData.returnPnr}
//                     onChange={handleChange}
//                     placeholder="e.g. XYZ987ABC"
//                     className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
//                   />
//                 </div>
//               </>
//             ) : (
//               <div>
//                 <label className="block text-sm font-semibold text-gray-700 mb-2">PNR / Reference No (Optional)</label>
//                 <input
//                   type="text"
//                   name="pnr"
//                   value={formData.pnr}
//                   onChange={handleChange}
//                   placeholder="e.g. ABC123XYZ"
//                   className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
//                 />
//               </div>
//             )}

//             {/* Price */}
//             <div>
//               <label className="block text-sm font-semibold text-gray-700 mb-2">Price / Amount (₹)</label>
//               <input
//                 type="number"
//                 name="price"
//                 value={formData.price}
//                 onChange={handleChange}
//                 placeholder="e.g. 5000"
//                 min="0"
//                 className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
//               />
//             </div>

//             {/* File */}
//             <div>
//               <label className="block text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
//                 <FaFileUpload className="text-gray-400" /> Upload E-Ticket (PDF)
//               </label>
//               <input
//                 type="file"
//                 accept=".pdf,image/*"
//                 onChange={(e) => setFile(e.target.files[0])}
//                 className="w-full px-4 py-1.5 border border-gray-300 rounded-lg file:mr-4 file:py-1 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
//               />
//             </div>
//           </div>

//           <div className="mt-8 flex justify-end gap-3 pt-6 border-t border-gray-100">
//             <button
//               type="button"
//               onClick={onClose}
//               disabled={submitting}
//               className="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium disabled:opacity-50"
//             >
//               Cancel
//             </button>
//             <button
//               type="submit"
//               disabled={submitting}
//               className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium disabled:opacity-50 flex items-center gap-2"
//             >
//               {submitting ? "Saving..." : "Create Booking"}
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };
// export default AdminCustomFlightModal;




import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaTimes, FaPlane, FaCalendarAlt, FaUser, FaFileUpload, FaPlus, FaTrash } from "react-icons/fa";
import { toast } from "react-toastify";

const inputCls = "w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none";
const smallInputCls = "w-full px-3 py-1.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none text-sm";
const labelCls = "block text-sm font-semibold text-gray-700 mb-2";
const smallLabelCls = "block text-xs font-semibold text-gray-600 mb-1";

const emptySsr = () => ({
  seatNo: "",
  seatType: "",
  seatCategory: "",
  seatFee: "",
  mealType: "",
  mealCode: "",
  mealName: "",
  mealFee: "",
  extraBaggage: "",
  baggageFee: "",
  specialBaggage: "",
});

const emptyPassenger = () => ({
  title: "Mr",
  firstName: "",
  lastName: "",
  type: "ADT",
  gender: "",
  dob: "",
  phone: "",
  email: "",
  passportNumber: "",
  passportExpiry: "",
  passportCountry: "",
  nationality: "",
  ssr: { onward: emptySsr(), return: emptySsr() },
});

const emptySegment = () => ({
  airline: "",
  flightNo: "",
  departureTime: "",
  arrivalTime: "",
  terminalFrom: "",
  terminalTo: "",
  duration: "",
  stops: 0,
  layovers: [],
  cabinClass: "Economy",
  fareType: "",
  cabinBaggage: "",
  checkinBaggage: "",
});

const num = (v) => Number(v) || 0;

const AdminCustomFlightModal = ({ onClose, onSuccess }) => {
  const [users, setUsers] = useState([]);
  const [loadingUsers, setLoadingUsers] = useState(true);
  const [airports, setAirports] = useState([]);

  const [formData, setFormData] = useState({
    userId: "",
    fromCity: "",
    toCity: "",
    tripType: "One Way",
    departureDate: "",
    returnDate: "",
    pnr: "",
    returnPnr: "",
    price: "",
    // new fields
    flightType: "Domestic",
    ssrOption: "Without SSR",
    ticketNumber: "",
    returnTicketNumber: "",
    bookingStatus: "Confirmed",
    contactPhone: "",
    contactEmail: "",
    gstin: "",
    gstCompany: "",
    visaNote: "",
    baseFare: "",
    taxes: "",
    convenienceFee: "",
    paymentMode: "",
    cancellationPolicy: "",
    reschedulePolicy: "",
    checkinTime: "",
  });
  const [file, setFile] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [fromSearch, setFromSearch] = useState("");
  const [showFromDropdown, setShowFromDropdown] = useState(false);
  const [toSearch, setToSearch] = useState("");
  const [showToDropdown, setShowToDropdown] = useState(false);
  const [activeLayoverDropdown, setActiveLayoverDropdown] = useState(null);

  // new state
  const [passengers, setPassengers] = useState([emptyPassenger()]);
  const [onwardSegment, setOnwardSegment] = useState(emptySegment());
  const [returnSegment, setReturnSegment] = useState(emptySegment());

  const isInternational = formData.flightType === "International";
  const isRoundTrip = formData.tripType === "Round Trip";
  const hasSSR = formData.ssrOption === "With SSR";

  const filteredUsers = users.filter((u) => {
    const searchLower = searchTerm.toLowerCase();
    const name = u.username?.toLowerCase() || "";
    const email = u.email?.toLowerCase() || "";
    return name.includes(searchLower) || email.includes(searchLower);
  });

  const filteredFromAirports = airports.filter((a) => {
    const searchLower = fromSearch.toLowerCase();
    const code = a.airportcode?.toLowerCase() || a.code?.toLowerCase() || "";
    const name = a.airportname?.toLowerCase() || a.name?.toLowerCase() || "";
    const city = a.airportcity?.toLowerCase() || a.city?.toLowerCase() || "";
    return code.includes(searchLower) || name.includes(searchLower) || city.includes(searchLower);
  }).slice(0, 20);

  const filteredToAirports = airports.filter((a) => {
    const searchLower = toSearch.toLowerCase();
    const code = a.airportcode?.toLowerCase() || a.code?.toLowerCase() || "";
    const name = a.airportname?.toLowerCase() || a.name?.toLowerCase() || "";
    const city = a.airportcity?.toLowerCase() || a.city?.toLowerCase() || "";
    return code.includes(searchLower) || name.includes(searchLower) || city.includes(searchLower);
  }).slice(0, 20);

  useEffect(() => {
    fetchUsers();
    fetchAirports();
  }, []);

  const fetchAirports = async () => {
    try {
      const BASE = import.meta.env.VITE_URL || import.meta.env.VITE_URL2 || "http://localhost:3000";
      const res = await axios.get(`${BASE}/api/airport`, { withCredentials: true });
      if (res.data.success && res.data.data) {
        setAirports(res.data.data);
      }
    } catch (err) {
      console.error("Failed to load airports", err);
    }
  };

  const fetchUsers = async () => {
    try {
      const BASE = import.meta.env.VITE_URL || import.meta.env.VITE_URL2 || "http://localhost:3000";
      const res = await axios.get(`${BASE}/api/user?limit=1000`, { withCredentials: true });
      if (res.data.success) {
        setUsers(res.data.data);
      }
    } catch (err) {
      console.error("Failed to load users", err);
      toast.error("Failed to load users for dropdown");
    } finally {
      setLoadingUsers(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // ---------- passengers helpers ----------
  const updatePassenger = (idx, field, value) => {
    setPassengers(prev => prev.map((p, i) => (i === idx ? { ...p, [field]: value } : p)));
  };

  const updatePassengerSsr = (idx, direction, field, value) => {
    setPassengers(prev =>
      prev.map((p, i) =>
        i === idx
          ? { ...p, ssr: { ...p.ssr, [direction]: { ...p.ssr[direction], [field]: value } } }
          : p
      )
    );
  };

  const addPassenger = () => setPassengers(prev => [...prev, emptyPassenger()]);

  const removePassenger = (idx) => {
    setPassengers(prev => (prev.length === 1 ? prev : prev.filter((_, i) => i !== idx)));
  };

  // ---------- segment helpers ----------
  const updateSegment = (direction, field, value) => {
    const setState = direction === "onward" ? setOnwardSegment : setReturnSegment;
    if (field === "stops") {
      const stopsCount = Math.max(0, parseInt(value, 10) || 0);
      setState(prev => {
        const newLayovers = [...(prev.layovers || [])];
        while (newLayovers.length < stopsCount) {
          newLayovers.push({ airport: "", duration: "", terminal: "" });
        }
        if (newLayovers.length > stopsCount) {
          newLayovers.length = stopsCount;
        }
        return { ...prev, stops: stopsCount, layovers: newLayovers };
      });
    } else {
      setState(prev => ({ ...prev, [field]: value }));
    }
  };

  const updateLayover = (direction, layoverIndex, field, value) => {
    const setState = direction === "onward" ? setOnwardSegment : setReturnSegment;
    setState(prev => {
      const newLayovers = [...(prev.layovers || [])];
      newLayovers[layoverIndex] = { ...newLayovers[layoverIndex], [field]: value };
      return { ...prev, layovers: newLayovers };
    });
  };

  // ---------- totals ----------
  const ssrTotal = hasSSR
    ? passengers.reduce((sum, p) => {
      const dirs = isRoundTrip ? ["onward", "return"] : ["onward"];
      return (
        sum +
        dirs.reduce((s, d) => {
          const x = p.ssr[d];
          return s + num(x.seatFee) + num(x.mealFee) + num(x.baggageFee);
        }, 0)
      );
    }, 0)
    : 0;

  const calculatedTotal = num(formData.baseFare) + num(formData.taxes) + num(formData.convenienceFee) + ssrTotal;

  const handleAutoTotal = () => {
    setFormData(prev => ({ ...prev, price: String(calculatedTotal) }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.userId || !formData.fromCity || !formData.toCity || !formData.departureDate) {
      toast.error("Please fill all required fields");
      return;
    }

    if (formData.tripType === "Round Trip" && !formData.returnDate) {
      toast.error("Return date is required for round trips");
      return;
    }

    // new validations
    for (let i = 0; i < passengers.length; i++) {
      const p = passengers[i];
      if (!p.firstName.trim() || !p.lastName.trim()) {
        toast.error(`Passenger ${i + 1}: first name and last name are required`);
        return;
      }
      if (isInternational) {
        if (!p.passportNumber.trim() || !p.passportExpiry) {
          toast.error(`Passenger ${i + 1}: passport number and expiry are required for international flights`);
          return;
        }
      }
    }

    setSubmitting(true);
    try {
      const BASE = import.meta.env.VITE_URL || import.meta.env.VITE_URL2 || "http://localhost:3000";
      const payload = new FormData();
      payload.append("userId", formData.userId);
      payload.append("fromCity", formData.fromCity);
      payload.append("toCity", formData.toCity);
      payload.append("tripType", formData.tripType);
      payload.append("departureDate", formData.departureDate);
      if (formData.returnDate) payload.append("returnDate", formData.returnDate);
      if (formData.pnr) payload.append("pnr", formData.pnr);
      if (formData.returnPnr && formData.tripType === "Round Trip") payload.append("returnPnr", formData.returnPnr);
      if (formData.price) payload.append("price", formData.price);
      if (file) payload.append("eTicket", file);

      // ---------- new fields ----------
      payload.append("flightType", formData.flightType);
      payload.append("ssrOption", formData.ssrOption);
      payload.append("hasSSR", hasSSR ? "true" : "false");
      if (formData.ticketNumber) payload.append("ticketNumber", formData.ticketNumber);
      if (formData.returnTicketNumber && isRoundTrip) payload.append("returnTicketNumber", formData.returnTicketNumber);
      if (formData.bookingStatus) payload.append("bookingStatus", formData.bookingStatus);
      if (formData.contactPhone) payload.append("contactPhone", formData.contactPhone);
      if (formData.contactEmail) payload.append("contactEmail", formData.contactEmail);

      if (!isInternational) {
        if (formData.gstin) payload.append("gstin", formData.gstin);
        if (formData.gstCompany) payload.append("gstCompany", formData.gstCompany);
      } else if (formData.visaNote) {
        payload.append("visaNote", formData.visaNote);
      }

      // passengers (passport only for international, ssr only when With SSR)
      const cleanPassengers = passengers.map((p) => {
        const base = {
          title: p.title,
          firstName: p.firstName.trim(),
          lastName: p.lastName.trim(),
          type: p.type,
          gender: p.gender,
          dob: p.dob,
          phone: p.phone,
          email: p.email,
          frequentFlyer: p.frequentFlyer,
        };
        if (isInternational) {
          base.passport = {
            number: p.passportNumber.trim(),
            expiry: p.passportExpiry,
            country: p.passportCountry,
            nationality: p.nationality,
          };
        }
        if (hasSSR) {
          base.ssr = { onward: p.ssr.onward };
          if (isRoundTrip) base.ssr.return = p.ssr.return;
        }
        return base;
      });
      payload.append("passengers", JSON.stringify(cleanPassengers));

      // segments
      const segments = [{ direction: "onward", ...onwardSegment }];
      if (isRoundTrip) segments.push({ direction: "return", ...returnSegment });
      payload.append("segments", JSON.stringify(segments));

      // fare
      payload.append(
        "fare",
        JSON.stringify({
          baseFare: num(formData.baseFare),
          taxes: num(formData.taxes),
          convenienceFee: num(formData.convenienceFee),
          ssrTotal: ssrTotal,
          total: num(formData.price),
          currency: "INR",
          paymentMode: formData.paymentMode,
        })
      );

      // rules
      payload.append(
        "rules",
        JSON.stringify({
          cancellation: formData.cancellationPolicy,
          reschedule: formData.reschedulePolicy,
          checkinTime: formData.checkinTime,
        })
      );

      const res = await axios.post(`${BASE}/api/booking/admin/custom-booking`, payload, {
        withCredentials: true,
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (res.data.success) {
        toast.success("Custom flight booked successfully");
        onSuccess();
      }
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.message || "Failed to create custom flight");
    } finally {
      setSubmitting(false);
    }
  };

  // ---------- reusable render blocks ----------
  const renderSegmentForm = (direction) => {
    const seg = direction === "onward" ? onwardSegment : returnSegment;
    const heading = direction === "onward" ? "Onward Flight Details" : "Return Flight Details";
    return (
      <div className="col-span-1 md:col-span-2 border border-gray-200 rounded-lg p-4 bg-gray-50">
        <h4 className="text-sm font-bold text-gray-800 mb-3 flex items-center gap-2">
          <FaPlane className="text-blue-500" /> {heading}
        </h4>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
          <div>
            <label className={smallLabelCls}>Airline</label>
            <input type="text" value={seg.airline} onChange={(e) => updateSegment(direction, "airline", e.target.value)} placeholder="e.g. IndiGo" className={smallInputCls} />
          </div>
          <div>
            <label className={smallLabelCls}>Flight No.</label>
            <input type="text" value={seg.flightNo} onChange={(e) => updateSegment(direction, "flightNo", e.target.value)} placeholder="e.g. 6E-2045" className={smallInputCls} />
          </div>
          <div>
            <label className={smallLabelCls}>Cabin Class</label>
            <select value={seg.cabinClass} onChange={(e) => updateSegment(direction, "cabinClass", e.target.value)} className={smallInputCls}>
              <option>Economy</option>
              <option>Premium Economy</option>
              <option>Business</option>
              <option>First</option>
            </select>
          </div>
          <div>
            <label className={smallLabelCls}>Departure Time</label>
            <input type="datetime-local" value={seg.departureTime} onChange={(e) => updateSegment(direction, "departureTime", e.target.value)} className={smallInputCls} />
          </div>
          <div>
            <label className={smallLabelCls}>Arrival Time</label>
            <input type="datetime-local" value={seg.arrivalTime} onChange={(e) => updateSegment(direction, "arrivalTime", e.target.value)} className={smallInputCls} />
          </div>
          <div>
            <label className={smallLabelCls}>Duration</label>
            <input type="text" value={seg.duration} onChange={(e) => updateSegment(direction, "duration", e.target.value)} placeholder="e.g. 2h 10m" className={smallInputCls} />
          </div>
          <div>
            <label className={smallLabelCls}>Terminal (From)</label>
            <input type="text" value={seg.terminalFrom} onChange={(e) => updateSegment(direction, "terminalFrom", e.target.value)} placeholder="e.g. T3" className={smallInputCls} />
          </div>
          <div>
            <label className={smallLabelCls}>Terminal (To)</label>
            <input type="text" value={seg.terminalTo} onChange={(e) => updateSegment(direction, "terminalTo", e.target.value)} placeholder="e.g. T2" className={smallInputCls} />
          </div>
          <div>
            <label className={smallLabelCls}>Stops</label>
            <input type="number" min="0" value={seg.stops} onChange={(e) => updateSegment(direction, "stops", e.target.value)} placeholder="0" className={smallInputCls} />
          </div>
          <div>
            <label className={smallLabelCls}>Fare Type</label>
            <input type="text" value={seg.fareType} onChange={(e) => updateSegment(direction, "fareType", e.target.value)} placeholder="e.g. Saver / Flexi" className={smallInputCls} />
          </div>
          <div>
            <label className={smallLabelCls}>Cabin Baggage</label>
            <input type="text" value={seg.cabinBaggage} onChange={(e) => updateSegment(direction, "cabinBaggage", e.target.value)} placeholder="e.g. 7 kg" className={smallInputCls} />
          </div>
          <div>
            <label className={smallLabelCls}>Check-in Baggage</label>
            <input type="text" value={seg.checkinBaggage} onChange={(e) => updateSegment(direction, "checkinBaggage", e.target.value)} placeholder="e.g. 15 kg" className={smallInputCls} />
          </div>
          {(seg.layovers || []).map((layover, index) => (
            <React.Fragment key={index}>
              <div className="col-span-1 md:col-span-3 mt-2 border-t border-gray-200 pt-2">
                <h5 className="text-xs font-bold text-gray-700">Stop {index + 1} Details</h5>
              </div>
              <div className="relative">
                <label className={smallLabelCls}>Layover Airport / City</label>
                <input
                  type="text"
                  value={layover.airport}
                  onChange={(e) => {
                    updateLayover(direction, index, "airport", e.target.value);
                    setActiveLayoverDropdown(`${direction}-${index}`);
                  }}
                  onFocus={() => setActiveLayoverDropdown(`${direction}-${index}`)}
                  onBlur={() => setTimeout(() => {
                    if (activeLayoverDropdown === `${direction}-${index}`) setActiveLayoverDropdown(null);
                  }, 200)}
                  placeholder="e.g. Dubai (DXB)"
                  className={smallInputCls}
                />
                {activeLayoverDropdown === `${direction}-${index}` && layover.airport && (
                  <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-40 overflow-auto">
                    {(() => {
                      const searchLower = layover.airport.toLowerCase();
                      const filtered = airports.filter((a) => {
                        const code = a.airportcode?.toLowerCase() || a.code?.toLowerCase() || "";
                        const name = a.airportname?.toLowerCase() || a.name?.toLowerCase() || "";
                        const city = a.airportcity?.toLowerCase() || a.city?.toLowerCase() || "";
                        return code.includes(searchLower) || name.includes(searchLower) || city.includes(searchLower);
                      }).slice(0, 20);
                      
                      return filtered.length > 0 ? (
                        filtered.map((a, idx) => {
                          const display = `${a.airportcity || a.city} (${a.airportcode || a.code})`;
                          return (
                            <div
                              key={idx}
                              className="px-4 py-2 cursor-pointer hover:bg-blue-50 text-sm"
                              onMouseDown={(e) => {
                                e.preventDefault();
                                updateLayover(direction, index, "airport", display);
                                setActiveLayoverDropdown(null);
                              }}
                            >
                              <div className="font-semibold">{a.airportcity || a.city}</div>
                              <div className="text-xs text-gray-500">{a.airportname || a.name} - {a.airportcode || a.code}</div>
                            </div>
                          );
                        })
                      ) : (
                        <div className="px-4 py-2 text-gray-500 text-sm">No cities found</div>
                      );
                    })()}
                  </div>
                )}
              </div>
              <div>
                <label className={smallLabelCls}>Layover Duration</label>
                <input type="text" value={layover.duration} onChange={(e) => updateLayover(direction, index, "duration", e.target.value)} placeholder="e.g. 3h 20m" className={smallInputCls} />
              </div>
              <div>
                <label className={smallLabelCls}>Layover Terminal</label>
                <input type="text" value={layover.terminal} onChange={(e) => updateLayover(direction, index, "terminal", e.target.value)} placeholder="e.g. T3" className={smallInputCls} />
              </div>
            </React.Fragment>
          ))}
        </div>
      </div>
    );
  };

  const renderSsrBlock = (pIdx, direction) => {
    const p = passengers[pIdx];
    const s = p.ssr[direction];
    const title = direction === "onward" ? "Onward SSR" : "Return SSR";
    return (
      <div className="border border-blue-100 rounded-lg p-3 bg-blue-50/40 mt-3">
        <h5 className="text-xs font-bold text-blue-700 mb-2 uppercase tracking-wide">{title}</h5>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
          {/* Seat */}
          <div>
            <label className={smallLabelCls}>Seat No.</label>
            <input type="text" value={s.seatNo} onChange={(e) => updatePassengerSsr(pIdx, direction, "seatNo", e.target.value)} placeholder="e.g. 12A" className={smallInputCls} />
          </div>
          <div>
            <label className={smallLabelCls}>Seat Type</label>
            <select value={s.seatType} onChange={(e) => updatePassengerSsr(pIdx, direction, "seatType", e.target.value)} className={smallInputCls}>
              <option value="">Select</option>
              <option>Window</option>
              <option>Middle</option>
              <option>Aisle</option>
            </select>
          </div>
          <div>
            <label className={smallLabelCls}>Seat Category</label>
            <select value={s.seatCategory} onChange={(e) => updatePassengerSsr(pIdx, direction, "seatCategory", e.target.value)} className={smallInputCls}>
              <option value="">Select</option>
              <option>Standard</option>
              <option>Extra Legroom</option>
              <option>Front Row</option>
              <option>Emergency Exit</option>
            </select>
          </div>
          <div>
            <label className={smallLabelCls}>Seat Fee (₹)</label>
            <input type="number" min="0" value={s.seatFee} onChange={(e) => updatePassengerSsr(pIdx, direction, "seatFee", e.target.value)} placeholder="0" className={smallInputCls} />
          </div>

          {/* Meal */}
          <div>
            <label className={smallLabelCls}>Meal Type</label>
            <select value={s.mealType} onChange={(e) => updatePassengerSsr(pIdx, direction, "mealType", e.target.value)} className={smallInputCls}>
              <option value="">Select</option>
              <option>Veg</option>
              <option>Non-Veg</option>
              <option>Jain</option>
              <option>Diabetic</option>
              <option>Child Meal</option>
              <option>Special Meal</option>
            </select>
          </div>
          <div>
            <label className={smallLabelCls}>Meal Code</label>
            <input type="text" value={s.mealCode} onChange={(e) => updatePassengerSsr(pIdx, direction, "mealCode", e.target.value)} placeholder="e.g. VGML" className={smallInputCls} />
          </div>
          <div>
            <label className={smallLabelCls}>Meal Name</label>
            <input type="text" value={s.mealName} onChange={(e) => updatePassengerSsr(pIdx, direction, "mealName", e.target.value)} placeholder="e.g. Veg Sandwich" className={smallInputCls} />
          </div>
          <div>
            <label className={smallLabelCls}>Meal Fee (₹)</label>
            <input type="number" min="0" value={s.mealFee} onChange={(e) => updatePassengerSsr(pIdx, direction, "mealFee", e.target.value)} placeholder="0" className={smallInputCls} />
          </div>

          {/* Baggage */}
          <div>
            <label className={smallLabelCls}>Extra Baggage (kg)</label>
            <input type="number" min="0" value={s.extraBaggage} onChange={(e) => updatePassengerSsr(pIdx, direction, "extraBaggage", e.target.value)} placeholder="e.g. 5" className={smallInputCls} />
          </div>
          <div>
            <label className={smallLabelCls}>Baggage Fee (₹)</label>
            <input type="number" min="0" value={s.baggageFee} onChange={(e) => updatePassengerSsr(pIdx, direction, "baggageFee", e.target.value)} placeholder="0" className={smallInputCls} />
          </div>
          <div className="md:col-span-2">
            <label className={smallLabelCls}>Special Baggage (optional)</label>
            <input type="text" value={s.specialBaggage} onChange={(e) => updatePassengerSsr(pIdx, direction, "specialBaggage", e.target.value)} placeholder="e.g. Sports equipment, Musical instrument, Pet" className={smallInputCls} />
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center p-4 pt-10 pb-20 bg-black/60 overflow-y-auto">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-4xl relative">
        <div className="flex justify-between items-center p-6 border-b border-gray-100">
          <h2 className="text-xl font-bold text-gray-800 flex items-center gap-2">
            <FaPlane className="text-blue-500" /> Create Custom Flight Booking
          </h2>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-full text-gray-500 transition-colors">
            <FaTimes />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

            {/* User Selection */}
            <div className="col-span-1 md:col-span-2 relative">
              <label className="block text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
                <FaUser className="text-gray-400" /> Select User *
              </label>

              <div className="relative">
                <input
                  type="text"
                  placeholder="Search user by name or email..."
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                    setShowDropdown(true);
                    if (!e.target.value) setFormData(prev => ({ ...prev, userId: "" }));
                  }}
                  onFocus={() => setShowDropdown(true)}
                  onBlur={() => setShowDropdown(false)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                />

                {showDropdown && (
                  <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-auto">
                    {filteredUsers.length > 0 ? (
                      filteredUsers.map(u => (
                        <div
                          key={u._id}
                          className={`px-4 py-2 cursor-pointer hover:bg-blue-50 ${formData.userId === u._id ? "bg-blue-100" : ""}`}
                          onMouseDown={(e) => {
                            e.preventDefault(); // Prevents input blur before click registers
                            setFormData(prev => ({ ...prev, userId: u._id }));
                            setSearchTerm(`${u.username || u.email} (${u.email})`);
                            setShowDropdown(false);
                          }}
                        >
                          {u.username || u.email} ({u.email})
                        </div>
                      ))
                    ) : (
                      <div className="px-4 py-2 text-gray-500">No users found</div>
                    )}
                  </div>
                )}
              </div>
              {loadingUsers && <span className="text-xs text-blue-500 mt-1">Loading users...</span>}
            </div>

            {/* Flight Type (Domestic / International) */}
            <div className="col-span-1 md:col-span-2">
              <label className={labelCls}>Flight Type *</label>
              <div className="flex gap-4">
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="radio"
                    name="flightType"
                    value="Domestic"
                    checked={formData.flightType === "Domestic"}
                    onChange={handleChange}
                    className="w-4 h-4 text-blue-600 focus:ring-blue-500"
                  />
                  <span>Domestic</span>
                </label>
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="radio"
                    name="flightType"
                    value="International"
                    checked={formData.flightType === "International"}
                    onChange={handleChange}
                    className="w-4 h-4 text-blue-600 focus:ring-blue-500"
                  />
                  <span>International</span>
                </label>
              </div>
            </div>

            {/* Cities */}
            <div className="relative">
              <label className="block text-sm font-semibold text-gray-700 mb-2">From City *</label>
              <input
                type="text"
                placeholder="E.g. Delhi (DEL)"
                value={fromSearch}
                onChange={(e) => {
                  setFromSearch(e.target.value);
                  setShowFromDropdown(true);
                  if (!e.target.value) setFormData(prev => ({ ...prev, fromCity: "" }));
                }}
                onFocus={() => setShowFromDropdown(true)}
                onBlur={() => setShowFromDropdown(false)}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
              />
              {showFromDropdown && (
                <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-auto">
                  {filteredFromAirports.length > 0 ? (
                    filteredFromAirports.map((a, idx) => {
                      const display = `${a.airportcity || a.city} (${a.airportcode || a.code})`;
                      return (
                        <div
                          key={idx}
                          className="px-4 py-2 cursor-pointer hover:bg-blue-50 text-sm"
                          onMouseDown={(e) => {
                            e.preventDefault();
                            setFormData(prev => ({ ...prev, fromCity: display }));
                            setFromSearch(display);
                            setShowFromDropdown(false);
                          }}
                        >
                          <div className="font-semibold">{a.airportcity || a.city}</div>
                          <div className="text-xs text-gray-500">{a.airportname || a.name} - {a.airportcode || a.code}</div>
                        </div>
                      );
                    })
                  ) : (
                    <div className="px-4 py-2 text-gray-500">No cities found</div>
                  )}
                </div>
              )}
            </div>

            <div className="relative">
              <label className="block text-sm font-semibold text-gray-700 mb-2">To City *</label>
              <input
                type="text"
                placeholder="E.g. Mumbai (BOM)"
                value={toSearch}
                onChange={(e) => {
                  setToSearch(e.target.value);
                  setShowToDropdown(true);
                  if (!e.target.value) setFormData(prev => ({ ...prev, toCity: "" }));
                }}
                onFocus={() => setShowToDropdown(true)}
                onBlur={() => setShowToDropdown(false)}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
              />
              {showToDropdown && (
                <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-auto">
                  {filteredToAirports.length > 0 ? (
                    filteredToAirports.map((a, idx) => {
                      const display = `${a.airportcity || a.city} (${a.airportcode || a.code})`;
                      return (
                        <div
                          key={idx}
                          className="px-4 py-2 cursor-pointer hover:bg-blue-50 text-sm"
                          onMouseDown={(e) => {
                            e.preventDefault();
                            setFormData(prev => ({ ...prev, toCity: display }));
                            setToSearch(display);
                            setShowToDropdown(false);
                          }}
                        >
                          <div className="font-semibold">{a.airportcity || a.city}</div>
                          <div className="text-xs text-gray-500">{a.airportname || a.name} - {a.airportcode || a.code}</div>
                        </div>
                      );
                    })
                  ) : (
                    <div className="px-4 py-2 text-gray-500">No cities found</div>
                  )}
                </div>
              )}
            </div>

            {/* Trip Type */}
            <div className="col-span-1 md:col-span-2">
              <label className="block text-sm font-semibold text-gray-700 mb-2">Trip Type *</label>
              <div className="flex gap-4">
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="radio"
                    name="tripType"
                    value="One Way"
                    checked={formData.tripType === "One Way"}
                    onChange={handleChange}
                    className="w-4 h-4 text-blue-600 focus:ring-blue-500"
                  />
                  <span>One Way</span>
                </label>
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="radio"
                    name="tripType"
                    value="Round Trip"
                    checked={formData.tripType === "Round Trip"}
                    onChange={handleChange}
                    className="w-4 h-4 text-blue-600 focus:ring-blue-500"
                  />
                  <span>Round Trip</span>
                </label>
              </div>
            </div>

            {/* SSR Option */}
            <div className="col-span-1 md:col-span-2">
              <label className={labelCls}>SSR (Seat / Meal / Baggage) *</label>
              <div className="flex gap-4">
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="radio"
                    name="ssrOption"
                    value="Without SSR"
                    checked={formData.ssrOption === "Without SSR"}
                    onChange={handleChange}
                    className="w-4 h-4 text-blue-600 focus:ring-blue-500"
                  />
                  <span>Without SSR</span>
                </label>
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="radio"
                    name="ssrOption"
                    value="With SSR"
                    checked={formData.ssrOption === "With SSR"}
                    onChange={handleChange}
                    className="w-4 h-4 text-blue-600 focus:ring-blue-500"
                  />
                  <span>With SSR</span>
                </label>
              </div>
              <p className="text-xs text-gray-500 mt-1">
                "With SSR" select karne par har passenger ke liye seat, meal aur extra baggage ki details bharne ko milengi.
              </p>
            </div>

            {/* Dates */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
                <FaCalendarAlt className="text-gray-400" /> Departure Date *
              </label>
              <input
                type="date"
                name="departureDate"
                value={formData.departureDate}
                onChange={handleChange}
                required
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
              />
            </div>
            {formData.tripType === "Round Trip" && (
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
                  <FaCalendarAlt className="text-gray-400" /> Return Date *
                </label>
                <input
                  type="date"
                  name="returnDate"
                  value={formData.returnDate}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                />
              </div>
            )}

            {/* PNR */}
            {formData.tripType === "Round Trip" ? (
              <>
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">Onward PNR (Optional)</label>
                  <input
                    type="text"
                    name="pnr"
                    value={formData.pnr}
                    onChange={handleChange}
                    placeholder="e.g. ABC123XYZ"
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                  />
                </div>
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">Return PNR (Optional)</label>
                  <input
                    type="text"
                    name="returnPnr"
                    value={formData.returnPnr}
                    onChange={handleChange}
                    placeholder="e.g. XYZ987ABC"
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                  />
                </div>
              </>
            ) : (
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">PNR / Reference No (Optional)</label>
                <input
                  type="text"
                  name="pnr"
                  value={formData.pnr}
                  onChange={handleChange}
                  placeholder="e.g. ABC123XYZ"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                />
              </div>
            )}

            {/* Ticket Numbers + Status */}
            <div>
              <label className={labelCls}>Ticket Number (Optional)</label>
              <input
                type="text"
                name="ticketNumber"
                value={formData.ticketNumber}
                onChange={handleChange}
                placeholder="e.g. 098-1234567890"
                className={inputCls}
              />
            </div>
            {isRoundTrip && (
              <div>
                <label className={labelCls}>Return Ticket Number (Optional)</label>
                <input
                  type="text"
                  name="returnTicketNumber"
                  value={formData.returnTicketNumber}
                  onChange={handleChange}
                  placeholder="e.g. 098-9876543210"
                  className={inputCls}
                />
              </div>
            )}
            <div>
              <label className={labelCls}>Booking Status</label>
              <select name="bookingStatus" value={formData.bookingStatus} onChange={handleChange} className={inputCls}>
                <option>Confirmed</option>
                <option>On-hold</option>
                <option>Cancelled</option>
              </select>
            </div>

            {/* Contact */}
            <div>
              <label className={labelCls}>Contact Phone</label>
              <input
                type="text"
                name="contactPhone"
                value={formData.contactPhone}
                onChange={handleChange}
                placeholder="e.g. 9876543210"
                className={inputCls}
              />
            </div>
            <div>
              <label className={labelCls}>Contact Email</label>
              <input
                type="email"
                name="contactEmail"
                value={formData.contactEmail}
                onChange={handleChange}
                placeholder="e.g. customer@gmail.com"
                className={inputCls}
              />
            </div>

            {/* Domestic: GST | International: Visa note */}
            {!isInternational ? (
              <>
                <div>
                  <label className={labelCls}>GSTIN (Optional)</label>
                  <input
                    type="text"
                    name="gstin"
                    value={formData.gstin}
                    onChange={handleChange}
                    placeholder="e.g. 23ABCDE1234F1Z5"
                    className={inputCls}
                  />
                </div>
                <div>
                  <label className={labelCls}>GST Company Name (Optional)</label>
                  <input
                    type="text"
                    name="gstCompany"
                    value={formData.gstCompany}
                    onChange={handleChange}
                    placeholder="Company name"
                    className={inputCls}
                  />
                </div>
              </>
            ) : (
              <div className="col-span-1 md:col-span-2">
                <label className={labelCls}>Visa Info / Note (Optional)</label>
                <input
                  type="text"
                  name="visaNote"
                  value={formData.visaNote}
                  onChange={handleChange}
                  placeholder="e.g. Visa required / Visa on arrival / Transit visa required"
                  className={inputCls}
                />
              </div>
            )}

            {/* Flight details */}
            {renderSegmentForm("onward")}
            {isRoundTrip && renderSegmentForm("return")}

            {/* Passengers */}
            <div className="col-span-1 md:col-span-2">
              <div className="flex items-center justify-between mb-3">
                <h3 className="text-base font-bold text-gray-800 flex items-center gap-2">
                  <FaUser className="text-blue-500" /> Passenger Details
                </h3>
                <button
                  type="button"
                  onClick={addPassenger}
                  className="px-3 py-1.5 text-sm bg-blue-50 text-blue-700 rounded-lg hover:bg-blue-100 transition-colors font-medium flex items-center gap-2"
                >
                  <FaPlus /> Add Passenger
                </button>
              </div>

              <div className="space-y-4">
                {passengers.map((p, pIdx) => (
                  <div key={pIdx} className="border border-gray-200 rounded-lg p-4">
                    <div className="flex items-center justify-between mb-3">
                      <h4 className="text-sm font-bold text-gray-700">Passenger {pIdx + 1}</h4>
                      {passengers.length > 1 && (
                        <button
                          type="button"
                          onClick={() => removePassenger(pIdx)}
                          className="p-2 text-red-500 hover:bg-red-50 rounded-full transition-colors"
                        >
                          <FaTrash />
                        </button>
                      )}
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
                      <div>
                        <label className={smallLabelCls}>Title</label>
                        <select value={p.title} onChange={(e) => updatePassenger(pIdx, "title", e.target.value)} className={smallInputCls}>
                          <option>Mr</option>
                          <option>Ms</option>
                          <option>Mrs</option>
                          <option>Mstr</option>
                          <option>Miss</option>
                        </select>
                      </div>
                      <div>
                        <label className={smallLabelCls}>First Name *</label>
                        <input type="text" value={p.firstName} onChange={(e) => updatePassenger(pIdx, "firstName", e.target.value)} placeholder="As per ID / passport" className={smallInputCls} />
                      </div>
                      <div>
                        <label className={smallLabelCls}>Last Name *</label>
                        <input type="text" value={p.lastName} onChange={(e) => updatePassenger(pIdx, "lastName", e.target.value)} placeholder="As per ID / passport" className={smallInputCls} />
                      </div>
                      <div>
                        <label className={smallLabelCls}>Passenger Type</label>
                        <select value={p.type} onChange={(e) => updatePassenger(pIdx, "type", e.target.value)} className={smallInputCls}>
                          <option value="ADT">Adult</option>
                          <option value="CHD">Child</option>
                          <option value="INF">Infant</option>
                        </select>
                      </div>
                      <div>
                        <label className={smallLabelCls}>Gender</label>
                        <select value={p.gender} onChange={(e) => updatePassenger(pIdx, "gender", e.target.value)} className={smallInputCls}>
                          <option value="">Select</option>
                          <option>Male</option>
                          <option>Female</option>
                          <option>Other</option>
                        </select>
                      </div>
                      <div>
                        <label className={smallLabelCls}>Date of Birth</label>
                        <input type="date" value={p.dob} onChange={(e) => updatePassenger(pIdx, "dob", e.target.value)} className={smallInputCls} />
                      </div>
                      <div>
                        <label className={smallLabelCls}>Phone</label>
                        <input type="text" value={p.phone} onChange={(e) => updatePassenger(pIdx, "phone", e.target.value)} placeholder="Optional" className={smallInputCls} />
                      </div>
                      <div>
                        <label className={smallLabelCls}>Email</label>
                        <input type="email" value={p.email} onChange={(e) => updatePassenger(pIdx, "email", e.target.value)} placeholder="Optional" className={smallInputCls} />
                      </div>
                    </div>

                    {/* Passport - only International */}
                    {isInternational && (
                      <div className="mt-3 border border-amber-200 bg-amber-50/50 rounded-lg p-3">
                        <h5 className="text-xs font-bold text-amber-700 mb-2 uppercase tracking-wide">Passport Details *</h5>
                        <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
                          <div>
                            <label className={smallLabelCls}>Passport Number *</label>
                            <input type="text" value={p.passportNumber} onChange={(e) => updatePassenger(pIdx, "passportNumber", e.target.value)} placeholder="e.g. N1234567" className={smallInputCls} />
                          </div>
                          <div>
                            <label className={smallLabelCls}>Expiry Date *</label>
                            <input type="date" value={p.passportExpiry} onChange={(e) => updatePassenger(pIdx, "passportExpiry", e.target.value)} className={smallInputCls} />
                          </div>
                          <div>
                            <label className={smallLabelCls}>Issuing Country</label>
                            <input type="text" value={p.passportCountry} onChange={(e) => updatePassenger(pIdx, "passportCountry", e.target.value)} placeholder="e.g. India" className={smallInputCls} />
                          </div>
                          <div>
                            <label className={smallLabelCls}>Nationality</label>
                            <input type="text" value={p.nationality} onChange={(e) => updatePassenger(pIdx, "nationality", e.target.value)} placeholder="e.g. Indian" className={smallInputCls} />
                          </div>
                        </div>
                      </div>
                    )}

                    {/* SSR - only With SSR */}
                    {hasSSR && (
                      <>
                        {renderSsrBlock(pIdx, "onward")}
                        {isRoundTrip && renderSsrBlock(pIdx, "return")}
                      </>
                    )}
                  </div>
                ))}
              </div>
            </div>

            {/* Fare Breakup */}
            <div className="col-span-1 md:col-span-2 border border-gray-200 rounded-lg p-4 bg-gray-50">
              <h4 className="text-sm font-bold text-gray-800 mb-3">Fare Breakup (Optional)</h4>
              <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
                <div>
                  <label className={smallLabelCls}>Base Fare (₹)</label>
                  <input type="number" min="0" name="baseFare" value={formData.baseFare} onChange={handleChange} placeholder="0" className={smallInputCls} />
                </div>
                <div>
                  <label className={smallLabelCls}>Taxes & Fees (₹)</label>
                  <input type="number" min="0" name="taxes" value={formData.taxes} onChange={handleChange} placeholder="0" className={smallInputCls} />
                </div>
                <div>
                  <label className={smallLabelCls}>Convenience Fee (₹)</label>
                  <input type="number" min="0" name="convenienceFee" value={formData.convenienceFee} onChange={handleChange} placeholder="0" className={smallInputCls} />
                </div>
                <div>
                  <label className={smallLabelCls}>Payment Mode</label>
                  <input type="text" name="paymentMode" value={formData.paymentMode} onChange={handleChange} placeholder="e.g. UPI / Card / Cash" className={smallInputCls} />
                </div>
              </div>
              <div className="mt-3 flex flex-wrap items-center gap-3 text-sm text-gray-700">
                {hasSSR && <span>SSR Total: <b>₹{ssrTotal}</b></span>}
                <span>Calculated Total: <b>₹{calculatedTotal}</b></span>
                <button
                  type="button"
                  onClick={handleAutoTotal}
                  className="px-3 py-1 text-xs bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
                >
                  Use as Price / Amount
                </button>
              </div>
            </div>

            {/* Price */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">Price / Amount (₹)</label>
              <input
                type="number"
                name="price"
                value={formData.price}
                onChange={handleChange}
                placeholder="e.g. 5000"
                min="0"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
              />
            </div>

            {/* File */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
                <FaFileUpload className="text-gray-400" /> Upload E-Ticket (PDF)
              </label>
              <input
                type="file"
                accept=".pdf,image/*"
                onChange={(e) => setFile(e.target.files[0])}
                className="w-full px-4 py-1.5 border border-gray-300 rounded-lg file:mr-4 file:py-1 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
              />
            </div>

            {/* Rules */}
            <div className="col-span-1 md:col-span-2 border border-gray-200 rounded-lg p-4 bg-gray-50">
              <h4 className="text-sm font-bold text-gray-800 mb-3">Ticket Rules (Optional)</h4>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                <div>
                  <label className={smallLabelCls}>Cancellation Policy</label>
                  <textarea
                    name="cancellationPolicy"
                    value={formData.cancellationPolicy}
                    onChange={handleChange}
                    rows={3}
                    placeholder="e.g. ₹3,000 per sector before 24 hrs"
                    className={smallInputCls}
                  />
                </div>
                <div>
                  <label className={smallLabelCls}>Date Change Policy</label>
                  <textarea
                    name="reschedulePolicy"
                    value={formData.reschedulePolicy}
                    onChange={handleChange}
                    rows={3}
                    placeholder="e.g. ₹2,500 + fare difference"
                    className={smallInputCls}
                  />
                </div>
                <div>
                  <label className={smallLabelCls}>Check-in Timing</label>
                  <textarea
                    name="checkinTime"
                    value={formData.checkinTime}
                    onChange={handleChange}
                    rows={3}
                    placeholder={isInternational ? "e.g. Reach airport 3 hrs before" : "e.g. Reach airport 2 hrs before"}
                    className={smallInputCls}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="mt-8 flex justify-end gap-3 pt-6 border-t border-gray-100">
            <button
              type="button"
              onClick={onClose}
              disabled={submitting}
              className="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium disabled:opacity-50"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={submitting}
              className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium disabled:opacity-50 flex items-center gap-2"
            >
              {submitting ? "Saving..." : "Create Booking"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
export default AdminCustomFlightModal;